import mitt, { Emitter } from 'mitt'

type Events = {
  deviceUpgrade: any; // device upgrade
  deviceLogUploadProgress: any // device log upload
  flightTaskWs: any // dock task messages
  droneControlWs: any // flight command info
  droneControlMqttInfo: any // DRC link notifications
  flightAreasDroneLocationWs: any
  flightAreasSyncProgressWs: any
  flightAreasUpdateWs: any
};

const emitter: Emitter<Events> = mitt<Events>()

export default emitter
